import global from '../../../config/global';

const baseURL = global.apisUrl + '/batch-upload';

export const companyBatchUploadURL = baseURL + '/company';

export const onboardBatchUploadURL = baseURL + '/onboard';

export const emissionActivityBatchUploadURL = baseURL + '/emission-activity';

export const reductionDirectionBatchUploadURL = baseURL + `/reduction-direction`;

export const cnpBatchUploadURL = baseURL + '/cnp';

export const mitigationBatchUploadURL = baseURL + '/energy-asset-profile-mitigation';

export const esProgramBatchUploadURL = baseURL + '/es-program';
